import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-eventero-menu-button',
  templateUrl: './eventero-menu-button.component.html',
  styleUrls: ['./eventero-menu-button.component.scss'],
})
export class EventeroMenuButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
